import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["triangle", "line", "bar"]
  static values = { 
    showConfetti: Boolean,
    personalScore: Number,
    strategicScore: Number, 
    tacticalScore: Number
  }

  connect() {
    // Check if this is a fresh completion (confetti should only show once)
    if (this.showConfettiValue) {
      this.createConfetti()
    }
    
    this.animateTriangles()
    this.animateLines()
    this.animateBars()
  }

  animateTriangles() {
    this.triangleTargets.forEach((triangle, index) => {
      // Scale-up animation with staggered timing
      triangle.style.transform = 'scale(0)'
      triangle.style.transformOrigin = 'center'
      triangle.style.transition = `transform 1s ease-out ${index * 0.3}s`
      requestAnimationFrame(() => {
        triangle.style.transform = 'scale(1)'
      })
    })
  }

  animateLines() {
    this.lineTargets.forEach((line, index) => {
      // Fade-in animation with staggered timing
      line.style.opacity = '0'
      line.style.transition = `opacity 1.5s ease-out ${index * 0.2}s`
      requestAnimationFrame(() => {
        line.style.opacity = '1'
      })
    })
  }

  animateBars() {
    this.barTargets.forEach((bar, index) => {
      const score = parseFloat(bar.dataset.score)
      let currentWidth = 0
      const duration = 1500 // 1.5 seconds
      const steps = 60
      const increment = score / steps
      const delay = index * 200 // 200ms delay between bars
      
      // Start animation after delay
      setTimeout(() => {
        const animate = () => {
          if (currentWidth < score) {
            currentWidth += increment
            bar.style.width = `${currentWidth}%`
            requestAnimationFrame(animate)
          } else {
            bar.style.width = `${score}%`
          }
        }
        requestAnimationFrame(animate)
      }, delay)
    })
  }

  createConfetti() {
    const container = document.getElementById('confetti-container')
    if (!container) return

    const colors = ['#E4572E', '#17BEBB', '#F7B32B', '#FFA500', '#FF6B6B', '#4ECDC4']
    const confettiCount = 50

    for (let i = 0; i < confettiCount; i++) {
      setTimeout(() => {
        this.createConfettiPiece(container, colors)
      }, i * 50) // Stagger the confetti creation
    }

    // Clear confetti after animation
    setTimeout(() => {
      container.innerHTML = ''
    }, 4000)
  }

  createConfettiPiece(container, colors) {
    const confetti = document.createElement('div')
    const color = colors[Math.floor(Math.random() * colors.length)]
    const left = Math.random() * 100
    const animationDuration = Math.random() * 2 + 2 // 2-4 seconds
    const size = Math.random() * 8 + 4 // 4-12px

    confetti.style.cssText = `
      position: absolute;
      left: ${left}%;
      top: -10px;
      width: ${size}px;
      height: ${size}px;
      background: ${color};
      border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
      animation: confettiFall ${animationDuration}s linear forwards;
      z-index: 1000;
      transform: rotate(${Math.random() * 360}deg);
    `

    // Add CSS animation if not already present
    if (!document.querySelector('#confetti-style')) {
      const style = document.createElement('style')
      style.id = 'confetti-style'
      style.textContent = `
        @keyframes confettiFall {
          0% {
            transform: translateY(-10px) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
      `
      document.head.appendChild(style)
    }

    container.appendChild(confetti)
  }
}